// Typed access to the auth context.

import { useContext } from "react";
import AuthContext from "./auth-context";
import type { AuthContextShape } from "./types";

// auth-context.jsx creates the React context with an untyped placeholder default
// whose shape is narrower than the value AuthContextProvider supplies at runtime.
// Assert the real shape here, in one place, so consumers get a typed context
// without re-casting at each call site. The `unknown` step is required because the
// placeholder default and AuthContextShape do not structurally overlap; remove the
// assertion once auth-context is migrated to TypeScript and the context is created
// as React.createContext<AuthContextShape>.
export const useAuthContext = (): AuthContextShape =>
  useContext(AuthContext) as unknown as AuthContextShape;
